
export const scalefactor_huffman_codebook = [
  [18, 0x3ffe8], // 0
  [18, 0x3ffe6], // 1
  [18, 0x3ffe7], // 2
  [18, 0x3ffe5], // 3
  [19, 0x7fff5], // 4
  [19, 0x7fff1], // 5
  [19, 0x7ffed], // 6
  [19, 0x7fff6], // 7
  [19, 0x7ffee], // 8
  [19, 0x7ffef], // 9
  [19, 0x7fff0], // 10
  [19, 0x7fffc], // 11
  [19, 0x7fffd], // 12
  [19, 0x7ffff], // 13
  [19, 0x7fffe], // 14
  [19, 0x7fff7], // 15
  [19, 0x7fff8], // 16
  [19, 0x7fffb], // 17
  [19, 0x7fff9], // 18
  [18, 0x3ffe4], // 19
  [19, 0x7fffa], // 20
  [18, 0x3ffe3], // 21
  [17, 0x1ffef], // 22
  [17, 0x1fff0], // 23
  [16, 0xfff5], // 24
  [17, 0x1ffee], // 25
  [16, 0xfff2], // 26
  [16, 0xfff3], // 27
  [16, 0xfff4], // 28
  [16, 0xfff1], // 29
  [15, 0x7ff6], // 30
  [15, 0x7ff7], // 31
  [14, 0x3ff9], // 32
  [14, 0x3ff5], // 33
  [14, 0x3ff7], // 34
  [14, 0x3ff3], // 35
  [14, 0x3ff6], // 36
  [14, 0x3ff2], // 37
  [13, 0x1ff7], // 38
  [13, 0x1ff5], // 39
  [12, 0xff9], // 40
  [12, 0xff7], // 41
  [12, 0xff6], // 42
  [11, 0x7f9], // 43
  [12, 0xff4], // 44
  [11, 0x7f8], // 45
  [10, 0x3f9], // 46
  [10, 0x3f7], // 47
  [10, 0x3f5], // 48
  [9, 0x1f8], // 49
  [9, 0x1f7], // 50
  [8, 0xfa], // 51
  [8, 0xf8], // 52
  [8, 0xf6], // 53
  [7, 0x79], // 54
  [6, 0x3a], // 55
  [6, 0x38], // 56
  [5, 0x1a], // 57
  [4, 0xb], // 58
  [3, 0x4], // 59
  [1, 0x0], // 60
  [4, 0xa], // 61
  [4, 0xc], // 62
  [5, 0x1b], // 63
  [6, 0x39], // 64
  [6, 0x3b], // 65
  [7, 0x78], // 66
  [7, 0x7a], // 67
  [8, 0xf7], // 68
  [8, 0xf9], // 69
  [9, 0x1f6], // 70
  [9, 0x1f9], // 71
  [10, 0x3f4], // 72
  [10, 0x3f6], // 73
  [10, 0x3f8], // 74
  [11, 0x7f5], // 75
  [11, 0x7f4], // 76
  [11, 0x7f6], // 77
  [11, 0x7f7], // 78
  [12, 0xff5], // 79
  [12, 0xff8], // 80
  [13, 0x1ff4], // 81
  [13, 0x1ff6], // 82
  [13, 0x1ff8], // 83
  [14, 0x3ff8], // 84
  [14, 0x3ff4], // 85
  [16, 0xfff0], // 86
  [15, 0x7ff4], // 87
  [16, 0xfff6], // 88
  [15, 0x7ff5], // 89
  [18, 0x3ffe2], // 90
  [19, 0x7ffd9], // 91
  [19, 0x7ffda], // 92
  [19, 0x7ffdb], // 93
  [19, 0x7ffdc], // 94
  [19, 0x7ffdd], // 95
  [19, 0x7ffde], // 96
  [19, 0x7ffd8], // 97
  [19, 0x7ffd2], // 98
  [19, 0x7ffd3], // 99
  [19, 0x7ffd4], // 100
  [19, 0x7ffd5], // 101
  [19, 0x7ffd6], // 102
  [19, 0x7fff2], // 103
  [19, 0x7ffdf], // 104
  [19, 0x7ffe7], // 105
  [19, 0x7ffe8], // 106
  [19, 0x7ffe9], // 107
  [19, 0x7ffea], // 108
  [19, 0x7ffeb], // 109
  [19, 0x7ffe6], // 110
  [19, 0x7ffe0], // 111
  [19, 0x7ffe1], // 112
  [19, 0x7ffe2], // 113
  [19, 0x7ffe3], // 114
  [19, 0x7ffe4], // 115
  [19, 0x7ffe5], // 116
  [19, 0x7ffd7], // 117
  [19, 0x7ffec], // 118
  [19, 0x7fff4], // 119
  [19, 0x7fff3], // 120
];


export const spectrum_huffman_codebook_1 = [
  [11, 0x7f8], // 0
  [9, 0x1f1], // 1
  [11, 0x7fd], // 2
  [10, 0x3f5], // 3
  [7, 0x68], // 4
  [10, 0x3f0], // 5
  [11, 0x7f7], // 6
  [9, 0x1ec], // 7
  [11, 0x7f5], // 8
  [10, 0x3f1], // 9
  [7, 0x72], // 10
  [10, 0x3f4], // 11
  [7, 0x74], // 12
  [5, 0x11], // 13
  [7, 0x76], // 14
  [9, 0x1eb], // 15
  [7, 0x6c], // 16
  [10, 0x3f6], // 17
  [11, 0x7fc], // 18
  [9, 0x1e1], // 19
  [11, 0x7f1], // 20
  [9, 0x1f0], // 21
  [7, 0x61], // 22
  [9, 0x1f6], // 23
  [11, 0x7f2], // 24
  [9, 0x1ea], // 25
  [11, 0x7fb], // 26
  [9, 0x1f2], // 27
  [7, 0x69], // 28
  [9, 0x1ed], // 29
  [7, 0x77], // 30
  [5, 0x17], // 31
  [7, 0x6f], // 32
  [9, 0x1e6], // 33
  [7, 0x64], // 34
  [9, 0x1e5], // 35
  [7, 0x67], // 36
  [5, 0x15], // 37
  [7, 0x62], // 38
  [5, 0x12], // 39
  [1, 0x0], // 40
  [5, 0x14], // 41
  [7, 0x65], // 42
  [5, 0x16], // 43
  [7, 0x6d], // 44
  [9, 0x1e9], // 45
  [7, 0x63], // 46
  [9, 0x1e4], // 47
  [7, 0x6b], // 48
  [5, 0x13], // 49
  [7, 0x71], // 50
  [9, 0x1e3], // 51
  [7, 0x70], // 52
  [9, 0x1f3], // 53
  [11, 0x7fe], // 54
  [9, 0x1e7], // 55
  [11, 0x7f3], // 56
  [9, 0x1ef], // 57
  [7, 0x60], // 58
  [9, 0x1ee], // 59
  [11, 0x7f0], // 60
  [9, 0x1e2], // 61
  [11, 0x7fa], // 62
  [10, 0x3f3], // 63
  [7, 0x6a], // 64
  [9, 0x1e8], // 65
  [7, 0x75], // 66
  [5, 0x10], // 67
  [7, 0x73], // 68
  [9, 0x1f4], // 69
  [7, 0x6e], // 70
  [10, 0x3f7], // 71
  [11, 0x7f6], // 72
  [9, 0x1e0], // 73
  [11, 0x7f9], // 74
  [10, 0x3f2], // 75
  [7, 0x66], // 76
  [9, 0x1f5], // 77
  [11, 0x7ff], // 78
  [9, 0x1f7], // 79
  [11, 0x7f4], // 80
];

export const spectrum_huffman_codebook_2 = [
  [9, 0x1f3], // 0
  [7, 0x6f], // 1
  [9, 0x1fd], // 2
  [8, 0xeb], // 3
  [6, 0x23], // 4
  [8, 0xea], // 5
  [9, 0x1f7], // 6
  [8, 0xe8], // 7
  [9, 0x1fa], // 8
  [8, 0xf2], // 9
  [6, 0x2d], // 10
  [7, 0x70], // 11
  [6, 0x20], // 12
  [5, 0x6], // 13
  [6, 0x2b], // 14
  [7, 0x6e], // 15
  [6, 0x28], // 16
  [8, 0xe9], // 17
  [9, 0x1f9], // 18
  [7, 0x66], // 19
  [8, 0xf8], // 20
  [8, 0xe7], // 21
  [6, 0x1b], // 22
  [8, 0xf1], // 23
  [9, 0x1f4], // 24
  [7, 0x6b], // 25
  [9, 0x1f5], // 26
  [8, 0xec], // 27
  [6, 0x2a], // 28
  [7, 0x6c], // 29
  [6, 0x2c], // 30
  [5, 0xa], // 31
  [6, 0x27], // 32
  [7, 0x67], // 33
  [6, 0x1a], // 34
  [8, 0xf5], // 35
  [6, 0x24], // 36
  [5, 0x8], // 37
  [6, 0x1f], // 38
  [5, 0x9], // 39
  [3, 0x0], // 40
  [5, 0x7], // 41
  [6, 0x1d], // 42
  [5, 0xb], // 43
  [6, 0x30], // 44
  [8, 0xef], // 45
  [6, 0x1c], // 46
  [7, 0x64], // 47
  [6, 0x1e], // 48
  [5, 0xc], // 49
  [6, 0x29], // 50
  [8, 0xf3], // 51
  [6, 0x2f], // 52
  [8, 0xf0], // 53
  [9, 0x1fc], // 54
  [7, 0x71], // 55
  [9, 0x1f2], // 56
  [8, 0xf4], // 57
  [6, 0x21], // 58
  [8, 0xe6], // 59
  [8, 0xf7], // 60
  [7, 0x68], // 61
  [9, 0x1f8], // 62
  [8, 0xee], // 63
  [6, 0x22], // 64
  [7, 0x65], // 65
  [6, 0x31], // 66
  [4, 0x2], // 67
  [6, 0x26], // 68
  [8, 0xed], // 69
  [6, 0x25], // 70
  [7, 0x6a], // 71
  [9, 0x1fb], // 72
  [7, 0x72], // 73
  [9, 0x1fe], // 74
  [7, 0x69], // 75
  [6, 0x2e], // 76
  [8, 0xf6], // 77
  [9, 0x1ff], // 78
  [7, 0x6d], // 79
  [9, 0x1f6], // 80
];

export const spectrum_huffman_codebook_3 = [
  [1, 0x0], // 0
  [4, 0x9], // 1
  [8, 0xef], // 2
  [4, 0xb], // 3
  [5, 0x19], // 4
  [8, 0xf0], // 5
  [9, 0x1eb], // 6
  [9, 0x1e6], // 7
  [10, 0x3f2], // 8
  [4, 0xa], // 9
  [6, 0x35], // 10
  [9, 0x1ef], // 11
  [6, 0x34], // 12
  [6, 0x37], // 13
  [9, 0x1e9], // 14
  [9, 0x1ed], // 15
  [9, 0x1e7], // 16
  [10, 0x3f3], // 17
  [9, 0x1ee], // 18
  [10, 0x3ed], // 19
  [13, 0x1ffa], // 20
  [9, 0x1ec], // 21
  [9, 0x1f2], // 22
  [11, 0x7f9], // 23
  [11, 0x7f8], // 24
  [10, 0x3f8], // 25
  [12, 0xff8], // 26
  [4, 0x8], // 27
  [6, 0x38], // 28
  [10, 0x3f6], // 29
  [6, 0x36], // 30
  [7, 0x75], // 31
  [10, 0x3f1], // 32
  [10, 0x3eb], // 33
  [10, 0x3ec], // 34
  [12, 0xff4], // 35
  [5, 0x18], // 36
  [7, 0x76], // 37
  [11, 0x7f4], // 38
  [6, 0x39], // 39
  [7, 0x74], // 40
  [10, 0x3ef], // 41
  [9, 0x1f3], // 42
  [9, 0x1f4], // 43
  [11, 0x7f6], // 44
  [9, 0x1e8], // 45
  [10, 0x3ea], // 46
  [13, 0x1ffc], // 47
  [8, 0xf2], // 48
  [9, 0x1f1], // 49
  [12, 0xffb], // 50
  [10, 0x3f5], // 51
  [11, 0x7f3], // 52
  [12, 0xffc], // 53
  [8, 0xee], // 54
  [10, 0x3f7], // 55
  [15, 0x7ffe], // 56
  [9, 0x1f0], // 57
  [11, 0x7f5], // 58
  [15, 0x7ffd], // 59
  [13, 0x1ffb], // 60
  [14, 0x3ffa], // 61
  [16, 0xffff], // 62
  [8, 0xf1], // 63
  [10, 0x3f0], // 64
  [14, 0x3ffc], // 65
  [9, 0x1ea], // 66
  [10, 0x3ee], // 67
  [14, 0x3ffb], // 68
  [12, 0xff6], // 69
  [12, 0xffa], // 70
  [15, 0x7ffc], // 71
  [11, 0x7f2], // 72
  [12, 0xff5], // 73
  [16, 0xfffe], // 74
  [10, 0x3f4], // 75
  [11, 0x7f7], // 76
  [15, 0x7ffb], // 77
  [12, 0xff7], // 78
  [12, 0xff9], // 79
  [15, 0x7ffa], // 80
];

export const spectrum_huffman_codebook_4 = [
  [4, 0x7], // 0
  [5, 0x16], // 1
  [8, 0xf6], // 2
  [5, 0x18], // 3
  [4, 0x8], // 4
  [8, 0xef], // 5
  [9, 0x1ef], // 6
  [8, 0xf3], // 7
  [11, 0x7f8], // 8
  [5, 0x19], // 9
  [5, 0x17], // 10
  [8, 0xed], // 11
  [5, 0x15], // 12
  [4, 0x1], // 13
  [8, 0xe2], // 14
  [8, 0xf0], // 15
  [7, 0x70], // 16
  [10, 0x3f0], // 17
  [9, 0x1ee], // 18
  [8, 0xf1], // 19
  [11, 0x7fa], // 20
  [8, 0xee], // 21
  [8, 0xe4], // 22
  [10, 0x3f2], // 23
  [11, 0x7f6], // 24
  [10, 0x3ef], // 25
  [11, 0x7fd], // 26
  [4, 0x5], // 27
  [5, 0x14], // 28
  [8, 0xf2], // 29
  [4, 0x9], // 30
  [4, 0x4], // 31
  [8, 0xe5], // 32
  [8, 0xf4], // 33
  [8, 0xe8], // 34
  [10, 0x3f4], // 35
  [4, 0x6], // 36
  [4, 0x2], // 37
  [8, 0xe7], // 38
  [4, 0x3], // 39
  [4, 0x0], // 40
  [7, 0x6b], // 41
  [8, 0xe3], // 42
  [7, 0x69], // 43
  [9, 0x1f3], // 44
  [8, 0xeb], // 45
  [8, 0xe6], // 46
  [10, 0x3f6], // 47
  [7, 0x6e], // 48
  [7, 0x6a], // 49
  [9, 0x1f4], // 50
  [10, 0x3ec], // 51
  [9, 0x1f0], // 52
  [10, 0x3f9], // 53
  [8, 0xf5], // 54
  [8, 0xec], // 55
  [11, 0x7fb], // 56
  [8, 0xea], // 57
  [7, 0x6f], // 58
  [10, 0x3f7], // 59
  [11, 0x7f9], // 60
  [10, 0x3f3], // 61
  [12, 0xfff], // 62
  [8, 0xe9], // 63
  [7, 0x6d], // 64
  [10, 0x3f8], // 65
  [7, 0x6c], // 66
  [7, 0x68], // 67
  [9, 0x1f5], // 68
  [10, 0x3ee], // 69
  [9, 0x1f2], // 70
  [11, 0x7f4], // 71
  [11, 0x7f7], // 72
  [10, 0x3f1], // 73
  [12, 0xffe], // 74
  [10, 0x3ed], // 75
  [9, 0x1f1], // 76
  [11, 0x7f5], // 77
  [11, 0x7fe], // 78
  [10, 0x3f5], // 79
  [11, 0x7fc], // 80
];

export const spectrum_huffman_codebook_5 = [
  [13, 0x1fff], // 0
  [12, 0xff7], // 1
  [11, 0x7f4], // 2
  [11, 0x7e8], // 3
  [10, 0x3f1], // 4
  [11, 0x7ee], // 5
  [11, 0x7f9], // 6
  [12, 0xff8], // 7
  [13, 0x1ffd], // 8
  [12, 0xffd], // 9
  [11, 0x7f1], // 10
  [10, 0x3e8], // 11
  [9, 0x1e8], // 12
  [8, 0xf0], // 13
  [9, 0x1ec], // 14
  [10, 0x3ee], // 15
  [11, 0x7f2], // 16
  [12, 0xffa], // 17
  [12, 0xff4], // 18
  [10, 0x3ef], // 19
  [9, 0x1f2], // 20
  [8, 0xe8], // 21
  [7, 0x70], // 22
  [8, 0xec], // 23
  [9, 0x1f0], // 24
  [10, 0x3ea], // 25
  [11, 0x7f3], // 26
  [11, 0x7eb], // 27
  [9, 0x1eb], // 28
  [8, 0xea], // 29
  [5, 0x1a], // 30
  [4, 0x8], // 31
  [5, 0x19], // 32
  [8, 0xee], // 33
  [9, 0x1ef], // 34
  [11, 0x7ed], // 35
  [10, 0x3f0], // 36
  [8, 0xf2], // 37
  [7, 0x73], // 38
  [4, 0xb], // 39
  [1, 0x0], // 40
  [4, 0xa], // 41
  [7, 0x71], // 42
  [8, 0xf3], // 43
  [11, 0x7e9], // 44
  [11, 0x7ef], // 45
  [9, 0x1ee], // 46
  [8, 0xef], // 47
  [5, 0x18], // 48
  [4, 0x9], // 49
  [5, 0x1b], // 50
  [8, 0xeb], // 51
  [9, 0x1e9], // 52
  [11, 0x7ec], // 53
  [11, 0x7f6], // 54
  [10, 0x3eb], // 55
  [9, 0x1f3], // 56
  [8, 0xed], // 57
  [7, 0x72], // 58
  [8, 0xe9], // 59
  [9, 0x1f1], // 60
  [10, 0x3ed], // 61
  [11, 0x7f7], // 62
  [12, 0xff6], // 63
  [11, 0x7f0], // 64
  [10, 0x3e9], // 65
  [9, 0x1ed], // 66
  [8, 0xf1], // 67
  [9, 0x1ea], // 68
  [10, 0x3ec], // 69
  [11, 0x7f8], // 70
  [12, 0xff9], // 71
  [13, 0x1ffc], // 72
  [12, 0xffc], // 73
  [12, 0xff5], // 74
  [11, 0x7ea], // 75
  [10, 0x3f3], // 76
  [10, 0x3f2], // 77
  [11, 0x7f5], // 78
  [12, 0xffb], // 79
  [13, 0x1ffe], // 80
];

export const spectrum_huffman_codebook_6 = [
  [11, 0x7fe], // 0
  [10, 0x3fd], // 1
  [9, 0x1f1], // 2
  [9, 0x1eb], // 3
  [9, 0x1f4], // 4
  [9, 0x1ea], // 5
  [9, 0x1f0], // 6
  [10, 0x3fc], // 7
  [11, 0x7fd], // 8
  [10, 0x3f6], // 9
  [9, 0x1e5], // 10
  [8, 0xea], // 11
  [7, 0x6c], // 12
  [7, 0x71], // 13
  [7, 0x68], // 14
  [8, 0xf0], // 15
  [9, 0x1e6], // 16
  [10, 0x3f7], // 17
  [9, 0x1f3], // 18
  [8, 0xef], // 19
  [6, 0x32], // 20
  [6, 0x27], // 21
  [6, 0x28], // 22
  [6, 0x26], // 23
  [6, 0x31], // 24
  [8, 0xeb], // 25
  [9, 0x1f7], // 26
  [9, 0x1e8], // 27
  [7, 0x6f], // 28
  [6, 0x2e], // 29
  [4, 0x8], // 30
  [4, 0x4], // 31
  [4, 0x6], // 32
  [6, 0x29], // 33
  [7, 0x6b], // 34
  [9, 0x1ee], // 35
  [9, 0x1ef], // 36
  [7, 0x72], // 37
  [6, 0x2d], // 38
  [4, 0x2], // 39
  [4, 0x0], // 40
  [4, 0x3], // 41
  [6, 0x2f], // 42
  [7, 0x73], // 43
  [9, 0x1fa], // 44
  [9, 0x1e7], // 45
  [7, 0x6e], // 46
  [6, 0x2b], // 47
  [4, 0x7], // 48
  [4, 0x1], // 49
  [4, 0x5], // 50
  [6, 0x2c], // 51
  [7, 0x6d], // 52
  [9, 0x1ec], // 53
  [9, 0x1f9], // 54
  [8, 0xee], // 55
  [6, 0x30], // 56
  [6, 0x24], // 57
  [6, 0x2a], // 58
  [6, 0x25], // 59
  [6, 0x33], // 60
  [8, 0xec], // 61
  [9, 0x1f2], // 62
  [10, 0x3f8], // 63
  [9, 0x1e4], // 64
  [8, 0xed], // 65
  [7, 0x6a], // 66
  [7, 0x70], // 67
  [7, 0x69], // 68
  [7, 0x74], // 69
  [8, 0xf1], // 70
  [10, 0x3fa], // 71
  [11, 0x7ff], // 72
  [10, 0x3f9], // 73
  [9, 0x1f6], // 74
  [9, 0x1ed], // 75
  [9, 0x1f8], // 76
  [9, 0x1e9], // 77
  [9, 0x1f5], // 78
  [10, 0x3fb], // 79
  [11, 0x7fc], // 80
];

export const spectrum_huffman_codebook_7 = [
  [1, 0x0], // 0
  [3, 0x5], // 1
  [6, 0x37], // 2
  [7, 0x74], // 3
  [8, 0xf2], // 4
  [9, 0x1eb], // 5
  [10, 0x3ed], // 6
  [11, 0x7f7], // 7
  [3, 0x4], // 8
  [4, 0xc], // 9
  [6, 0x35], // 10
  [7, 0x71], // 11
  [8, 0xec], // 12
  [8, 0xee], // 13
  [9, 0x1ee], // 14
  [9, 0x1f5], // 15
  [6, 0x36], // 16
  [6, 0x34], // 17
  [7, 0x72], // 18
  [8, 0xea], // 19
  [8, 0xf1], // 20
  [9, 0x1e9], // 21
  [9, 0x1f3], // 22
  [10, 0x3f5], // 23
  [7, 0x73], // 24
  [7, 0x70], // 25
  [8, 0xeb], // 26
  [8, 0xf0], // 27
  [9, 0x1f1], // 28
  [9, 0x1f0], // 29
  [10, 0x3ec], // 30
  [10, 0x3fa], // 31
  [8, 0xf3], // 32
  [8, 0xed], // 33
  [9, 0x1e8], // 34
  [9, 0x1ef], // 35
  [10, 0x3ef], // 36
  [10, 0x3f1], // 37
  [10, 0x3f9], // 38
  [11, 0x7fb], // 39
  [9, 0x1ed], // 40
  [8, 0xef], // 41
  [9, 0x1ea], // 42
  [9, 0x1f2], // 43
  [10, 0x3f3], // 44
  [10, 0x3f8], // 45
  [11, 0x7f9], // 46
  [11, 0x7fc], // 47
  [10, 0x3ee], // 48
  [9, 0x1ec], // 49
  [9, 0x1f4], // 50
  [10, 0x3f4], // 51
  [10, 0x3f7], // 52
  [11, 0x7f8], // 53
  [12, 0xffd], // 54
  [12, 0xffe], // 55
  [11, 0x7f6], // 56
  [10, 0x3f0], // 57
  [10, 0x3f2], // 58
  [10, 0x3f6], // 59
  [11, 0x7fa], // 60
  [11, 0x7fd], // 61
  [12, 0xffc], // 62
  [12, 0xfff], // 63
];

export const spectrum_huffman_codebook_8 = [
  [5, 0xe], // 0
  [4, 0x5], // 1
  [5, 0x10], // 2
  [6, 0x30], // 3
  [7, 0x6f], // 4
  [8, 0xf1], // 5
  [9, 0x1fa], // 6
  [10, 0x3fe], // 7
  [4, 0x3], // 8
  [3, 0x0], // 9
  [4, 0x4], // 10
  [5, 0x12], // 11
  [6, 0x2c], // 12
  [7, 0x6a], // 13
  [7, 0x75], // 14
  [8, 0xf8], // 15
  [5, 0xf], // 16
  [4, 0x2], // 17
  [4, 0x6], // 18
  [5, 0x14], // 19
  [6, 0x2e], // 20
  [7, 0x69], // 21
  [7, 0x72], // 22
  [8, 0xf5], // 23
  [6, 0x2f], // 24
  [5, 0x11], // 25
  [5, 0x13], // 26
  [6, 0x2a], // 27
  [6, 0x32], // 28
  [7, 0x6c], // 29
  [8, 0xec], // 30
  [8, 0xfa], // 31
  [7, 0x71], // 32
  [6, 0x2b], // 33
  [6, 0x2d], // 34
  [6, 0x31], // 35
  [7, 0x6d], // 36
  [7, 0x70], // 37
  [8, 0xf2], // 38
  [9, 0x1f9], // 39
  [8, 0xef], // 40
  [7, 0x68], // 41
  [6, 0x33], // 42
  [7, 0x6b], // 43
  [7, 0x6e], // 44
  [8, 0xee], // 45
  [8, 0xf9], // 46
  [10, 0x3fc], // 47
  [9, 0x1f8], // 48
  [7, 0x74], // 49
  [7, 0x73], // 50
  [8, 0xed], // 51
  [8, 0xf0], // 52
  [8, 0xf6], // 53
  [9, 0x1f6], // 54
  [9, 0x1fd], // 55
  [10, 0x3fd], // 56
  [8, 0xf3], // 57
  [8, 0xf4], // 58
  [8, 0xf7], // 59
  [9, 0x1f7], // 60
  [9, 0x1fb], // 61
  [9, 0x1fc], // 62
  [10, 0x3ff], // 63
];

export const spectrum_huffman_codebook_9 = [
  [1, 0x0], // 0
  [3, 0x5], // 1
  [6, 0x37], // 2
  [8, 0xe7], // 3
  [9, 0x1de], // 4
  [10, 0x3ce], // 5
  [10, 0x3d9], // 6
  [11, 0x7c8], // 7
  [11, 0x7cd], // 8
  [12, 0xfc8], // 9
  [12, 0xfdd], // 10
  [13, 0x1fe4], // 11
  [13, 0x1fec], // 12
  [3, 0x4], // 13
  [4, 0xc], // 14
  [6, 0x35], // 15
  [7, 0x72], // 16
  [8, 0xea], // 17
  [8, 0xed], // 18
  [9, 0x1e2], // 19
  [10, 0x3d1], // 20
  [10, 0x3d3], // 21
  [10, 0x3e0], // 22
  [11, 0x7d8], // 23
  [12, 0xfcf], // 24
  [12, 0xfd5], // 25
  [6, 0x36], // 26
  [6, 0x34], // 27
  [7, 0x71], // 28
  [8, 0xe8], // 29
  [8, 0xec], // 30
  [9, 0x1e1], // 31
  [10, 0x3cf], // 32
  [10, 0x3dd], // 33
  [10, 0x3db], // 34
  [11, 0x7d0], // 35
  [12, 0xfc7], // 36
  [12, 0xfd4], // 37
  [12, 0xfe4], // 38
  [8, 0xe6], // 39
  [7, 0x70], // 40
  [8, 0xe9], // 41
  [9, 0x1dd], // 42
  [9, 0x1e3], // 43
  [10, 0x3d2], // 44
  [10, 0x3dc], // 45
  [11, 0x7cc], // 46
  [11, 0x7ca], // 47
  [11, 0x7de], // 48
  [12, 0xfd8], // 49
  [12, 0xfea], // 50
  [13, 0x1fdb], // 51
  [9, 0x1df], // 52
  [8, 0xeb], // 53
  [9, 0x1dc], // 54
  [9, 0x1e6], // 55
  [10, 0x3d5], // 56
  [10, 0x3de], // 57
  [11, 0x7cb], // 58
  [11, 0x7dd], // 59
  [11, 0x7dc], // 60
  [12, 0xfcd], // 61
  [12, 0xfe2], // 62
  [12, 0xfe7], // 63
  [13, 0x1fe1], // 64
  [10, 0x3d0], // 65
  [9, 0x1e0], // 66
  [9, 0x1e4], // 67
  [10, 0x3d6], // 68
  [11, 0x7c5], // 69
  [11, 0x7d1], // 70
  [11, 0x7db], // 71
  [12, 0xfd2], // 72
  [11, 0x7e0], // 73
  [12, 0xfd9], // 74
  [12, 0xfeb], // 75
  [13, 0x1fe3], // 76
  [13, 0x1fe9], // 77
  [11, 0x7c4], // 78
  [9, 0x1e5], // 79
  [10, 0x3d7], // 80
  [11, 0x7c6], // 81
  [11, 0x7cf], // 82
  [11, 0x7da], // 83
  [12, 0xfcb], // 84
  [12, 0xfda], // 85
  [12, 0xfe3], // 86
  [12, 0xfe9], // 87
  [13, 0x1fe6], // 88
  [13, 0x1ff3], // 89
  [13, 0x1ff7], // 90
  [11, 0x7d3], // 91
  [10, 0x3d8], // 92
  [10, 0x3e1], // 93
  [11, 0x7d4], // 94
  [11, 0x7d9], // 95
  [12, 0xfd3], // 96
  [12, 0xfde], // 97
  [13, 0x1fdd], // 98
  [13, 0x1fd9], // 99
  [13, 0x1fe2], // 100
  [13, 0x1fea], // 101
  [13, 0x1ff1], // 102
  [13, 0x1ff6], // 103
  [11, 0x7d2], // 104
  [10, 0x3d4], // 105
  [10, 0x3da], // 106
  [11, 0x7c7], // 107
  [11, 0x7d7], // 108
  [11, 0x7e2], // 109
  [12, 0xfce], // 110
  [12, 0xfdb], // 111
  [13, 0x1fd8], // 112
  [13, 0x1fee], // 113
  [14, 0x3ff0], // 114
  [13, 0x1ff4], // 115
  [14, 0x3ff2], // 116
  [11, 0x7e1], // 117
  [10, 0x3df], // 118
  [11, 0x7c9], // 119
  [11, 0x7d6], // 120
  [12, 0xfca], // 121
  [12, 0xfd0], // 122
  [12, 0xfe5], // 123
  [12, 0xfe6], // 124
  [13, 0x1feb], // 125
  [13, 0x1fef], // 126
  [14, 0x3ff3], // 127
  [14, 0x3ff4], // 128
  [14, 0x3ff5], // 129
  [12, 0xfe0], // 130
  [11, 0x7ce], // 131
  [11, 0x7d5], // 132
  [12, 0xfc6], // 133
  [12, 0xfd1], // 134
  [12, 0xfe1], // 135
  [13, 0x1fe0], // 136
  [13, 0x1fe8], // 137
  [13, 0x1ff0], // 138
  [14, 0x3ff1], // 139
  [14, 0x3ff8], // 140
  [14, 0x3ff6], // 141
  [15, 0x7ffc], // 142
  [12, 0xfe8], // 143
  [11, 0x7df], // 144
  [12, 0xfc9], // 145
  [12, 0xfd7], // 146
  [12, 0xfdc], // 147
  [13, 0x1fdc], // 148
  [13, 0x1fdf], // 149
  [13, 0x1fed], // 150
  [13, 0x1ff5], // 151
  [14, 0x3ff9], // 152
  [14, 0x3ffb], // 153
  [15, 0x7ffd], // 154
  [15, 0x7ffe], // 155
  [13, 0x1fe7], // 156
  [12, 0xfcc], // 157
  [12, 0xfd6], // 158
  [12, 0xfdf], // 159
  [13, 0x1fde], // 160
  [13, 0x1fda], // 161
  [13, 0x1fe5], // 162
  [13, 0x1ff2], // 163
  [14, 0x3ffa], // 164
  [14, 0x3ff7], // 165
  [14, 0x3ffc], // 166
  [14, 0x3ffd], // 167
  [15, 0x7fff], // 168
];

export const spectrum_huffman_codebook_10 = [
  [6, 0x22], // 0
  [5, 0x8], // 1
  [6, 0x1d], // 2
  [6, 0x26], // 3
  [7, 0x5f], // 4
  [8, 0xd3], // 5
  [9, 0x1cf], // 6
  [10, 0x3d0], // 7
  [10, 0x3d7], // 8
  [10, 0x3ed], // 9
  [11, 0x7f0], // 10
  [11, 0x7f6], // 11
  [12, 0xffd], // 12
  [5, 0x7], // 13
  [4, 0x0], // 14
  [4, 0x1], // 15
  [5, 0x9], // 16
  [6, 0x20], // 17
  [7, 0x54], // 18
  [7, 0x60], // 19
  [8, 0xd5], // 20
  [8, 0xdc], // 21
  [9, 0x1d4], // 22
  [10, 0x3cd], // 23
  [10, 0x3de], // 24
  [11, 0x7e7], // 25
  [6, 0x1c], // 26
  [4, 0x2], // 27
  [5, 0x6], // 28
  [5, 0xc], // 29
  [6, 0x1e], // 30
  [6, 0x28], // 31
  [7, 0x5b], // 32
  [8, 0xcd], // 33
  [8, 0xd9], // 34
  [9, 0x1ce], // 35
  [9, 0x1dc], // 36
  [10, 0x3d9], // 37
  [10, 0x3f1], // 38
  [6, 0x25], // 39
  [5, 0xb], // 40
  [5, 0xa], // 41
  [5, 0xd], // 42
  [6, 0x24], // 43
  [7, 0x57], // 44
  [7, 0x61], // 45
  [8, 0xcc], // 46
  [8, 0xdd], // 47
  [9, 0x1cc], // 48
  [9, 0x1de], // 49
  [10, 0x3d3], // 50
  [10, 0x3e7], // 51
  [7, 0x5d], // 52
  [6, 0x21], // 53
  [6, 0x1f], // 54
  [6, 0x23], // 55
  [6, 0x27], // 56
  [7, 0x59], // 57
  [7, 0x64], // 58
  [8, 0xd8], // 59
  [8, 0xdf], // 60
  [9, 0x1d2], // 61
  [9, 0x1e2], // 62
  [10, 0x3dd], // 63
  [10, 0x3ee], // 64
  [8, 0xd1], // 65
  [7, 0x55], // 66
  [6, 0x29], // 67
  [7, 0x56], // 68
  [7, 0x58], // 69
  [7, 0x62], // 70
  [8, 0xce], // 71
  [8, 0xe0], // 72
  [8, 0xe2], // 73
  [9, 0x1da], // 74
  [10, 0x3d4], // 75
  [10, 0x3e3], // 76
  [11, 0x7eb], // 77
  [9, 0x1c9], // 78
  [7, 0x5e], // 79
  [7, 0x5a], // 80
  [7, 0x5c], // 81
  [7, 0x63], // 82
  [8, 0xca], // 83
  [8, 0xda], // 84
  [9, 0x1c7], // 85
  [9, 0x1ca], // 86
  [9, 0x1e0], // 87
  [10, 0x3db], // 88
  [10, 0x3e8], // 89
  [11, 0x7ec], // 90
  [9, 0x1e3], // 91
  [8, 0xd2], // 92
  [8, 0xcb], // 93
  [8, 0xd0], // 94
  [8, 0xd7], // 95
  [8, 0xdb], // 96
  [9, 0x1c6], // 97
  [9, 0x1d5], // 98
  [9, 0x1d8], // 99
  [10, 0x3ca], // 100
  [10, 0x3da], // 101
  [11, 0x7ea], // 102
  [11, 0x7f1], // 103
  [9, 0x1e1], // 104
  [8, 0xd4], // 105
  [8, 0xcf], // 106
  [8, 0xd6], // 107
  [8, 0xde], // 108
  [8, 0xe1], // 109
  [9, 0x1d0], // 110
  [9, 0x1d6], // 111
  [10, 0x3d1], // 112
  [10, 0x3d5], // 113
  [10, 0x3f2], // 114
  [11, 0x7ee], // 115
  [11, 0x7fb], // 116
  [10, 0x3e9], // 117
  [9, 0x1cd], // 118
  [9, 0x1c8], // 119
  [9, 0x1cb], // 120
  [9, 0x1d1], // 121
  [9, 0x1d7], // 122
  [9, 0x1df], // 123
  [10, 0x3cf], // 124
  [10, 0x3e0], // 125
  [10, 0x3ef], // 126
  [11, 0x7e6], // 127
  [11, 0x7f8], // 128
  [12, 0xffa], // 129
  [10, 0x3eb], // 130
  [9, 0x1dd], // 131
  [9, 0x1d3], // 132
  [9, 0x1d9], // 133
  [9, 0x1db], // 134
  [10, 0x3d2], // 135
  [10, 0x3cc], // 136
  [10, 0x3dc], // 137
  [10, 0x3ea], // 138
  [11, 0x7ed], // 139
  [11, 0x7f3], // 140
  [11, 0x7f9], // 141
  [12, 0xff9], // 142
  [11, 0x7f2], // 143
  [10, 0x3ce], // 144
  [9, 0x1e4], // 145
  [10, 0x3cb], // 146
  [10, 0x3d8], // 147
  [10, 0x3d6], // 148
  [10, 0x3e2], // 149
  [10, 0x3e5], // 150
  [11, 0x7e8], // 151
  [11, 0x7f4], // 152
  [11, 0x7f5], // 153
  [11, 0x7f7], // 154
  [12, 0xffb], // 155
  [11, 0x7fa], // 156
  [10, 0x3ec], // 157
  [10, 0x3df], // 158
  [10, 0x3e1], // 159
  [10, 0x3e4], // 160
  [10, 0x3e6], // 161
  [10, 0x3f0], // 162
  [11, 0x7e9], // 163
  [11, 0x7ef], // 164
  [12, 0xff8], // 165
  [12, 0xffe], // 166
  [12, 0xffc], // 167
  [12, 0xfff], // 168
];

export const spectrum_huffman_codebook_11 = [
  [4, 0x0], // 0
  [5, 0x6], // 1
  [6, 0x19], // 2
  [7, 0x3d], // 3
  [8, 0x9c], // 4
  [8, 0xc6], // 5
  [9, 0x1a7], // 6
  [10, 0x390], // 7
  [10, 0x3c2], // 8
  [10, 0x3df], // 9
  [11, 0x7e6], // 10
  [11, 0x7f3], // 11
  [12, 0xffb], // 12
  [11, 0x7ec], // 13
  [12, 0xffa], // 14
  [12, 0xffe], // 15
  [10, 0x38e], // 16
  [5, 0x5], // 17
  [4, 0x1], // 18
  [5, 0x8], // 19
  [6, 0x14], // 20
  [7, 0x37], // 21
  [7, 0x42], // 22
  [8, 0x92], // 23
  [8, 0xaf], // 24
  [9, 0x191], // 25
  [9, 0x1a5], // 26
  [9, 0x1b5], // 27
  [10, 0x39e], // 28
  [10, 0x3c0], // 29
  [10, 0x3a2], // 30
  [10, 0x3cd], // 31
  [11, 0x7d6], // 32
  [8, 0xae], // 33
  [6, 0x17], // 34
  [5, 0x7], // 35
  [5, 0x9], // 36
  [6, 0x18], // 37
  [7, 0x39], // 38
  [7, 0x40], // 39
  [8, 0x8e], // 40
  [8, 0xa3], // 41
  [8, 0xb8], // 42
  [9, 0x199], // 43
  [9, 0x1ac], // 44
  [9, 0x1c1], // 45
  [10, 0x3b1], // 46
  [10, 0x396], // 47
  [10, 0x3be], // 48
  [10, 0x3ca], // 49
  [8, 0x9d], // 50
  [7, 0x3c], // 51
  [6, 0x15], // 52
  [6, 0x16], // 53
  [6, 0x1a], // 54
  [7, 0x3b], // 55
  [7, 0x44], // 56
  [8, 0x91], // 57
  [8, 0xa5], // 58
  [8, 0xbe], // 59
  [9, 0x196], // 60
  [9, 0x1ae], // 61
  [9, 0x1b9], // 62
  [10, 0x3a1], // 63
  [10, 0x391], // 64
  [10, 0x3a5], // 65
  [10, 0x3d5], // 66
  [8, 0x94], // 67
  [8, 0x9a], // 68
  [7, 0x36], // 69
  [7, 0x38], // 70
  [7, 0x3a], // 71
  [7, 0x41], // 72
  [8, 0x8c], // 73
  [8, 0x9b], // 74
  [8, 0xb0], // 75
  [8, 0xc3], // 76
  [9, 0x19e], // 77
  [9, 0x1ab], // 78
  [9, 0x1bc], // 79
  [10, 0x39f], // 80
  [10, 0x38f], // 81
  [10, 0x3a9], // 82
  [10, 0x3cf], // 83
  [8, 0x93], // 84
  [8, 0xbf], // 85
  [7, 0x3e], // 86
  [7, 0x3f], // 87
  [7, 0x43], // 88
  [7, 0x45], // 89
  [8, 0x9e], // 90
  [8, 0xa7], // 91
  [8, 0xb9], // 92
  [9, 0x194], // 93
  [9, 0x1a2], // 94
  [9, 0x1ba], // 95
  [9, 0x1c3], // 96
  [10, 0x3a6], // 97
  [10, 0x3a7], // 98
  [10, 0x3bb], // 99
  [10, 0x3d4], // 100
  [8, 0x9f], // 101
  [9, 0x1a0], // 102
  [8, 0x8f], // 103
  [8, 0x8d], // 104
  [8, 0x90], // 105
  [8, 0x98], // 106
  [8, 0xa6], // 107
  [8, 0xb6], // 108
  [8, 0xc4], // 109
  [9, 0x19f], // 110
  [9, 0x1af], // 111
  [9, 0x1bf], // 112
  [10, 0x399], // 113
  [10, 0x3bf], // 114
  [10, 0x3b4], // 115
  [10, 0x3c9], // 116
  [10, 0x3e7], // 117
  [8, 0xa8], // 118
  [9, 0x1b6], // 119
  [8, 0xab], // 120
  [8, 0xa4], // 121
  [8, 0xaa], // 122
  [8, 0xb2], // 123
  [8, 0xc2], // 124
  [8, 0xc5], // 125
  [9, 0x198], // 126
  [9, 0x1a4], // 127
  [9, 0x1b8], // 128
  [10, 0x38c], // 129
  [10, 0x3a4], // 130
  [10, 0x3c4], // 131
  [10, 0x3c6], // 132
  [10, 0x3dd], // 133
  [10, 0x3e8], // 134
  [8, 0xad], // 135
  [10, 0x3af], // 136
  [9, 0x192], // 137
  [8, 0xbd], // 138
  [8, 0xbc], // 139
  [9, 0x18e], // 140
  [9, 0x197], // 141
  [9, 0x19a], // 142
  [9, 0x1a3], // 143
  [9, 0x1b1], // 144
  [10, 0x38d], // 145
  [10, 0x398], // 146
  [10, 0x3b7], // 147
  [10, 0x3d3], // 148
  [10, 0x3d1], // 149
  [10, 0x3db], // 150
  [11, 0x7dd], // 151
  [8, 0xb4], // 152
  [10, 0x3de], // 153
  [9, 0x1a9], // 154
  [9, 0x19b], // 155
  [9, 0x19c], // 156
  [9, 0x1a1], // 157
  [9, 0x1aa], // 158
  [9, 0x1ad], // 159
  [9, 0x1b3], // 160
  [10, 0x38b], // 161
  [10, 0x3b2], // 162
  [10, 0x3b8], // 163
  [10, 0x3ce], // 164
  [10, 0x3e1], // 165
  [10, 0x3e0], // 166
  [11, 0x7d2], // 167
  [11, 0x7e5], // 168
  [8, 0xb7], // 169
  [11, 0x7e3], // 170
  [9, 0x1bb], // 171
  [9, 0x1a8], // 172
  [9, 0x1a6], // 173
  [9, 0x1b0], // 174
  [9, 0x1b2], // 175
  [9, 0x1b7], // 176
  [10, 0x39b], // 177
  [10, 0x39a], // 178
  [10, 0x3ba], // 179
  [10, 0x3b5], // 180
  [10, 0x3d6], // 181
  [11, 0x7d7], // 182
  [10, 0x3e4], // 183
  [11, 0x7d8], // 184
  [11, 0x7ea], // 185
  [8, 0xba], // 186
  [11, 0x7e8], // 187
  [10, 0x3a0], // 188
  [9, 0x1bd], // 189
  [9, 0x1b4], // 190
  [10, 0x38a], // 191
  [9, 0x1c4], // 192
  [10, 0x392], // 193
  [10, 0x3aa], // 194
  [10, 0x3b0], // 195
  [10, 0x3bc], // 196
  [10, 0x3d7], // 197
  [11, 0x7d4], // 198
  [11, 0x7dc], // 199
  [11, 0x7db], // 200
  [11, 0x7d5], // 201
  [11, 0x7f0], // 202
  [8, 0xc1], // 203
  [11, 0x7fb], // 204
  [10, 0x3c8], // 205
  [10, 0x3a3], // 206
  [10, 0x395], // 207
  [10, 0x39d], // 208
  [10, 0x3ac], // 209
  [10, 0x3ae], // 210
  [10, 0x3c5], // 211
  [10, 0x3d8], // 212
  [10, 0x3e2], // 213
  [10, 0x3e6], // 214
  [11, 0x7e4], // 215
  [11, 0x7e7], // 216
  [11, 0x7e0], // 217
  [11, 0x7e9], // 218
  [11, 0x7f7], // 219
  [9, 0x190], // 220
  [11, 0x7f2], // 221
  [10, 0x393], // 222
  [9, 0x1be], // 223
  [9, 0x1c0], // 224
  [10, 0x394], // 225
  [10, 0x397], // 226
  [10, 0x3ad], // 227
  [10, 0x3c3], // 228
  [10, 0x3c1], // 229
  [10, 0x3d2], // 230
  [11, 0x7da], // 231
  [11, 0x7d9], // 232
  [11, 0x7df], // 233
  [11, 0x7eb], // 234
  [11, 0x7f4], // 235
  [11, 0x7fa], // 236
  [9, 0x195], // 237
  [11, 0x7f8], // 238
  [10, 0x3bd], // 239
  [10, 0x39c], // 240
  [10, 0x3ab], // 241
  [10, 0x3a8], // 242
  [10, 0x3b3], // 243
  [10, 0x3b9], // 244
  [10, 0x3d0], // 245
  [10, 0x3e3], // 246
  [10, 0x3e5], // 247
  [11, 0x7e2], // 248
  [11, 0x7de], // 249
  [11, 0x7ed], // 250
  [11, 0x7f1], // 251
  [11, 0x7f9], // 252
  [11, 0x7fc], // 253
  [9, 0x193], // 254
  [12, 0xffd], // 255
  [10, 0x3dc], // 256
  [10, 0x3b6], // 257
  [10, 0x3c7], // 258
  [10, 0x3cc], // 259
  [10, 0x3cb], // 260
  [10, 0x3d9], // 261
  [10, 0x3da], // 262
  [11, 0x7d3], // 263
  [11, 0x7e1], // 264
  [11, 0x7ee], // 265
  [11, 0x7ef], // 266
  [11, 0x7f5], // 267
  [11, 0x7f6], // 268
  [12, 0xffc], // 269
  [12, 0xfff], // 270
  [9, 0x19d], // 271
  [9, 0x1c2], // 272
  [8, 0xb5], // 273
  [8, 0xa1], // 274
  [8, 0x96], // 275
  [8, 0x97], // 276
  [8, 0x95], // 277
  [8, 0x99], // 278
  [8, 0xa0], // 279
  [8, 0xa2], // 280
  [8, 0xac], // 281
  [8, 0xa9], // 282
  [8, 0xb1], // 283
  [8, 0xb3], // 284
  [8, 0xbb], // 285
  [8, 0xc0], // 286
  [9, 0x18f], // 287
  [5, 0x4], // 288
];

